import React from 'react';
import { connect } from 'react-redux';
import LoginController from './../LoginLegacy/LoginController';
import { FEATURE_FLAGS, getFeatureFlagEnabledBool } from 'shared/reducers/featureFlag';

const SimpleCheckoutWithBillingController = React.lazy(() => (
  import('shared/components/SimpleCheckoutWithBilling/components/SimpleCheckoutWithBillingController' /* webpackChunkName: "SimpleCheckoutWithBillingController" */)
));

const PackageCheckoutMonarchController = React.lazy(() => (
  import('shared/components/PackageCheckoutMonarch/components/PackageCheckoutMonarchController' /* webpackChunkName: "PackageCheckoutMonarchController" */)
));

const DirectRouter = props => {
  const { userIsLoggedIn, selectedPackage, space, onPackageChange, fePackageCheckoutShortMonarch } = props;

  const CheckoutController = fePackageCheckoutShortMonarch
    ? PackageCheckoutMonarchController
    : SimpleCheckoutWithBillingController;

  if (!userIsLoggedIn) { return <LoginController skipPassword packageName={selectedPackage.displayName} redirectUrl={'?next=/direct'} />; }

  if (selectedPackage) {
    return space
      ? <CheckoutController
        {...props}
        columnName={'Design Package'}
        columnValue={'Price'}
        isMonarch={false} // For showing/hidng Monarch styles
        listItems={[selectedPackage]}
        listItemName={selectedPackage.displayName}
        listItemPrice={selectedPackage.price}
        onBack={props.handlePaymentBackClick}
        onPaymentSuccess={props.handlePaymentSuccess}
        packageSku={selectedPackage.packageSku}
        spaceInfo={space}
        title={'Order Summary'}
        onPackageChange={onPackageChange}
      />
      : null;
  }

  return null;
};

const mapStateToProps = state => {
  return {
    fePackageCheckoutShortMonarch: getFeatureFlagEnabledBool(FEATURE_FLAGS.PackageCheckoutShortMonarch, state)
  };
};

export default connect(mapStateToProps, null)(DirectRouter);
